module.exports = __webpack_public_path__ + "img/nature.ac831664.jpg";